// extracted by css-extract-rspack-plugin
export default {"Form":"RequestNonprofitWizard_Form__2XvF6","SubTitle":"RequestNonprofitWizard_SubTitle__27nu-"};